import React from "react";
import { Container, Divider, Row, Col, Link, CaptionText } from '@paypalcorp/pp-react';
import { triggerHelpCenter } from '../../common/domUtils';
import { get } from "lodash";
import { parseMessages } from '../../utilityHelper';
import ReactHtmlParser from 'react-html-parser';

const propertyInfo = parseMessages("footer");
const country = document.getElementById('data-country') && document.getElementById('data-country').innerHTML || '';

const GivingFooter = (props) => {
    const triggerHelp = () => {
        triggerHelpCenter();
    }
    const copyrightText = get(propertyInfo, `copyright.footer.${country}`, '').replace('{currentYear}', (new Date()).getFullYear());

    return (<Container className="givingFooter" fluid={true} style={{ background: "#FFF", bottom: "0", height: "150px", padding: "30px 0 20px 0" }}>
        {props.merchantFooter ? <div className="merchant-footer" style={{ display: 'block' }}></div> :
            <><Row>
                <Col>
                    <Link className="footerLink" href={country === 'IE' ? '/webapps/mpp/givingfund/howitworks' : '/webapps/mpp/givingfund/home'} secondary>{get(propertyInfo, 'footer.howitworks')}</Link>
                    <Link className="footerLink" href="/webapps/mpp/givingfund/about" secondary>{get(propertyInfo, 'footer.aboutus')}</Link>
                    <Link className="footerLink" onClick={triggerHelp} secondary>{ReactHtmlParser(get(propertyInfo, 'footer.helpandcontact'))}</Link>
                    <Link className="footerLink" href="/webapps/mpp/givingfund/policies" secondary>{get(propertyInfo, 'footer.policies')}</Link>
                </Col>
            </Row>
                <Divider />
                <Row>
                    <Col xs={8}>
                        <CaptionText>
                            {ReactHtmlParser(copyrightText)}
                        </CaptionText>
                    </Col>
                    <Col style={{ textAlign: 'right' }}>
                        <Link className="footerLink" size="sm" href="/webapps/mpp/givingfund/policies" secondary>
                            {get(propertyInfo, 'footer.privacyLabel')}
                        </Link>
                        <Link className="footerLink" size="sm" href={country === 'US' ? '/webapps/mpp/givingfund/policies/nonprofit-user-agreement' : '/webapps/mpp/givingfund/policies#Useragreement'} secondary>
                            {get(propertyInfo, 'footer.useragreement.label')}
                        </Link>
                    </Col>
                </Row>
            </>
        }
    </Container>)
}
export default GivingFooter;